exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "sponsor-list .sponsor-image {\n  height: 30px;\n  width: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/bs_work/toMigrate_litePortal/src/app/component-module/sponsor-list/sponsor-list.component.scss
// module id = ../../../../../src/app/component-module/sponsor-list/sponsor-list.component.scss
// module chunks = main